(ns common.schema.entities.feedback
  (:require [common.feedback-reasons :as feedback-reasons]
            [common.feedback-status :as feedback-status]
            [common.schema.entities.common :as common-schema]
            [common.schema.schema-utils :as su]))

(def schema
  (concat common-schema/common-owner-role
          common-schema/common-owner
          (su/keyword-field :feedback/reason "Feedback reason" feedback-reasons/options {:authorization su/access-owner-owner})
          (su/text-multiline-field :feedback/description "Feedback description" {:authorization su/access-owner-owner})
          (su/numeric-field :feedback/rating "Feedback rating" {:authorization su/access-owner-owner})
          (su/boolean-field :feedback/follow-up? "Feedback follow-up?" {:authorization su/access-owner-owner})
          (su/text-simple-field :feedback/uuid "Feedback unique ID" {:authorization            su/access-owner-owner
                                                                     :default-field-visibility :in-use-disabled})
          (su/keyword-field :feedback/status "Status" feedback-status/options {:editor-type              :editor.type/none
                                                                               :authorization            su/access-owner-owner
                                                                               :default-field-visibility :in-use-disabled
                                                                               :custom-sort?             true})
          (su/datetime-field :feedback/datetime-submitted-on "Submitted on" {:authorization su/access-owner-owner})))
